import { z } from 'zod/v4';

export const vehicleTypeOptions = [
  'Auto',
  'RV',
  'Heavy Duty',
  'Bus',
  'Light Duty',
  'Medium Duty',
] as const;
export const vehicleTypeSchema = z.enum(vehicleTypeOptions);

export type VehicleType = z.infer<typeof vehicleTypeSchema>;
